import { getToolDefinition } from '@src/app/features/dashboard/ai/pages/chat/chat-tool-definitions';

/**
 * Chat do Briefing (card 3878): ferramentas com título de negócio e sugestões do estado vazio. Sem Angular/DI.
 *
 * Ferramentas do chat (locais do agente e do MCP, preset `partnerDealBriefingRead` do Cog) com título no registro
 * `chat-tool-definitions.ts` (`tool-<nome>`). Ferramenta nova do chat: registre lá e acrescente aqui.
 */
export const BRIEFING_CHAT_TOOLS = [
  'executar_python',
  'pedir_revisao',
  'askUser',
  'ver_investigacao',
  'listar_achados_investigacao',
  'ver_contatos_e_enderecos',
  'consultar_documentos',
  'get_partner_deal',
  'get_partner_deal_timeline',
  'get_partner_deal_gates',
  'list_partner_deal_documents',
  'get_partner_deal_briefing',
  'list_partner_deal_meetings',
  'get_meeting',
  'get_meeting_insights',
  'get_income_statement',
  'get_balance_sheet',
  'get_financial_indicators',
  'get_financial_highlights',
  'get_revenue_statement',
  'get_liquidity_and_indebtedness',
  'get_net_revenue_and_ebitda_margin',
  'get_operational_and_financial_cycle',
  'get_consolidated_indebtedness',
  'get_debt_report',
  'list_loan_operations',
  'get_loan_summary_by_status',
  'get_cnpj_registration',
  'get_company_corporate_charter',
  'list_data_room_files',
  'list_data_room_folder',
  'search_data_room_files',
  'get_data_room_document_details',
  'get_data_room_completeness',
] as const;

/** `toolLabels` do `ChatProductMode` do chat do briefing, montado do registro. */
export const BRIEFING_CHAT_TOOL_LABELS: Readonly<Record<string, string>> = Object.fromEntries(
  BRIEFING_CHAT_TOOLS.map(tool => [tool, getToolDefinition(`tool-${tool}`).name])
);

/** Decisão da recomendação (`recommendation.decision`) como a pessoa lê no documento. */
const DECISION_LABELS: Readonly<Record<string, string>> = {
  PROCEED: 'Avançar',
  HOLD: 'Aguardar',
  DECLINE: 'Declinar',
};

/**
 * Sugestões do estado vazio do chat do briefing, no contrato da Q10 (`task-Q10-report.md`, "Contrato das sugestões
 * para o front"): perguntas sobre a empresa e um ajuste. A pergunta da recomendação usa a decisão da versão atual
 * (PROCEED, HOLD ou DECLINE no contrato, em português na pergunta); sem versão pronta, vira "O que falta para gerar o
 * briefing?". Decisão ainda não lida: a pergunta fica sem ela. Sem `PARTNERDEALBRIEFING_ADJUST` (`canAdjust` falso),
 * a sugestão de ajuste sai: o chat só responde perguntas, e a API recusa o pedido de ajuste.
 */
export function briefingChatSuggestions(
  hasReadyVersion: boolean,
  decision: string | null,
  canAdjust = true
): string[] {
  const recommendation = !hasReadyVersion
    ? 'O que falta para gerar o briefing?'
    : decision
      ? `Por que a recomendação é ${DECISION_LABELS[decision] ?? decision}?`
      : 'Por que o briefing recomenda isso?';
  const questions = [
    'Qual a margem EBITDA de 2025?',
    'Quais documentos faltam no Data Room?',
    'Como está o endividamento da empresa hoje?',
    recommendation,
  ];
  return canAdjust ? [...questions, 'Troque o múltiplo de referência para 3,0x'] : questions;
}
